import {override} from 'mobx';

import {StageDomainModel} from "../../../../domain/full-game/models/stage/stage-domain-model";
import {ScoreboardWidgetStageViewModel} from "../scoreboard-widget.stage-view-model";
import {AppTerms} from "../../../../core/app/app-terms";
import {SCOREBOARD} from "../../scoreboard-widget.consts";
import {ScoreboardWidgetTennisScoreCellViewModel} from "./scoreboard-widget.tennis.score-cell-view-model";

export class ScoreboardWidgetTennisStageViewModel extends ScoreboardWidgetStageViewModel {
  constructor(domainModel: StageDomainModel, isHomeCompetitorGameWinner: Boolean = false, isAwayCompetitorGameWinner: Boolean = false, terms: AppTerms) {
    super(domainModel, isHomeCompetitorGameWinner, isAwayCompetitorGameWinner);

    this.terms = terms;
  }

  @override get homeScore(): ScoreboardWidgetTennisScoreCellViewModel {
    const score = this._calcScore(this.domainModel.homeCompetitorScore);

    const homeScoreCell: ScoreboardWidgetTennisScoreCellViewModel = new ScoreboardWidgetTennisScoreCellViewModel(
      score,
      this.domainModel.homeCompetitorExtraScore,
      this.isHomeCompetitorWinner,
      this.domainModel.isCurrent,
      this.domainModel.isLive);

    return homeScoreCell;
  }

  @override get awayScore(): ScoreboardWidgetTennisScoreCellViewModel {
    const score = this._calcScore(this.domainModel.awayCompetitorScore);

    const awayScoreCell: ScoreboardWidgetTennisScoreCellViewModel = new ScoreboardWidgetTennisScoreCellViewModel(
      score,
      this.domainModel.awayCompetitorExtraScore,
      this.isAwayCompetitorWinner,
      this.domainModel.isCurrent,
      this.domainModel.isLive
    );

    return awayScoreCell;
  }

  _calcScore(score: Number) {
    const isGameStage = this.domainModel.id === SCOREBOARD.TENNIS.STAGE_IDS.GAME_STAGE;
    const calculatedScore = isGameStage && score === SCOREBOARD.TENNIS.ADVANTAGE_SCORE ? this.terms.TENNIS_SCORE_ADVANTAGE : score;

    return  calculatedScore;
  }
}
